import { render, staticRenderFns } from "./SAPPortalStatusMatrix.vue?vue&type=template&id=1d8f3e0c&scoped=true"
import script from "./SAPPortalStatusMatrix.vue?vue&type=script&lang=js"
export * from "./SAPPortalStatusMatrix.vue?vue&type=script&lang=js"
import style0 from "./SAPPortalStatusMatrix.vue?vue&type=style&index=0&id=1d8f3e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f3e0c",
  null
  
)

export default component.exports